export const SIREN_ENABLED = 'sirenEnabled';
